<template>
  <report-data-provider :requiredReports="requiredReports" v-model="reports" v-slot:default="{ loading, error, retry }">
    <card-loading v-if="loading" />
    <card-reload v-else-if="error" @reload="retry()"/>
    <average-card v-else :data="cardData"/>
  </report-data-provider>
</template>

<script>
import ReportDataProvider from '@/components/dashboard/ReportDataProvider.vue'
import CardLoading from '@/components/dashboard/CardLoading.vue'
import CardReload from '@/components/dashboard/CardReload.vue'
import AverageCard from '@/components/dashboard/efficiency/cards/AverageCard.vue'
import { colors } from '@/plugins/colors.js'

export default {
  components: {
    ReportDataProvider,
    CardLoading,
    CardReload,
    AverageCard
  },
  data () {
    return {
      requiredReports: ['countCompaniesInvitedByTpro'],
      reports: null
    }
  },
  computed: {
    cardData () {
      const { countCompaniesInvitedByTpro } = this.reports
      const series = countCompaniesInvitedByTpro.byPeriod.map((val, i) => ({
        x: i,
        y: val
      }))
      const labels = countCompaniesInvitedByTpro.byPeriod.map((_v, i) => ({
        value: i,
        label: this.$store.getters['dashboard/label'](i)
      }))
      const pointsLabels = countCompaniesInvitedByTpro.byPeriod.map((val, i) => ({
        x: i,
        y: val,
        label: val.toFixed(1)
      }))
      return {
        header: 'Компании, приглашенные ТендерПро',
        subheader: 'среднее кол-во на конкурс в стадии "Согласование" и "Закрыт"',
        unit: 'шт.',
        average: {
          count: countCompaniesInvitedByTpro.avg,
          percent: countCompaniesInvitedByTpro.percent,
          max: countCompaniesInvitedByTpro.max
        },
        series: {
          series,
          style: {
            color: colors[6]
          },
          pointsLabels: pointsLabels
        },
        plotConfig: {
          grid: { vertical: false, horizontal: false },
          axis: {
            x: labels,
            hidden: { y: true }
          },
          chartArea: {
            x: 5, y: 0, width: 90, height: 100
          }
        }
      }
    }
  }
}
</script>
